import type { MagicLinkState } from './AuthContext';

// FLOSEAI-439 — pure state transitions for the passwordless (magic-link) flow,
// extracted so the resend behaviour is unit-testable without the AuthProvider's
// runtime dependencies (Auth0, secure storage, analytics, Sentry).

/**
 * Next state when a (re)send begins.
 *
 * A resend triggered from the code-entry ('sent') screen MUST keep that screen
 * mounted — dropping to 'requesting' renders the email input again and causes
 * the ~1s flash users reported. Only the first send (from idle/error) shows the
 * 'requesting' phase.
 */
export function beginMagicLinkSend(prev: MagicLinkState): MagicLinkState {
  if (prev.kind === 'sent') {
    return { ...prev, resending: true, justResent: false };
  }
  return { kind: 'requesting' };
}

/**
 * State after the code email is successfully (re)sent. `wasResend` marks the
 * transition so the UI can show a "code resent" confirmation only on a resend,
 * not on the initial send.
 */
export function magicLinkSent(
  maskedEmail: string,
  lastSentAt: number,
  wasResend: boolean,
): MagicLinkState {
  return { kind: 'sent', maskedEmail, lastSentAt, justResent: wasResend };
}
